import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';
import { ProjectManagerDto } from './dtos/user-company.dto';
import { ProjectManagerMapper } from './mappers/project-manager.mapper';
import { ProjectManager } from '../models/project-manager.model';

@Injectable({ providedIn: 'root' })
export class UserProjectManagerApi {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _baseUrl = this._environmentConfig.pureSpectrum.url;
  private readonly _mapper = new ProjectManagerMapper();

  public projectManagers(companyId: number): Observable<ProjectManager[]> {
    return this._httpClient
      .get<
        ProjectManagerDto[]
      >(`${this._baseUrl}/companies/${companyId}/users?apiUsers=true`, { context: withLoading('content') })
      .pipe(map((dtos) => this._mapper.fromDtoList(dtos)));
  }
}
